import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import axios from 'axios'
import './assets/styles/global.scss'
import Vant from 'vant';
import 'vant/lib/index.css';
import tu111 from './assets/tu111.png'
import { initViewport } from './utils/viewport'
Vue.config.productionTip = false

// PAD 终端复用 H5 视图，通过固定 viewport 宽度实现等比缩放，保持样式/交互一致
initViewport()
Vue.use(ElementUI, {
  size: 'default',
})
Vue.use(Vant);

Vue.prototype.$message = function(options) {
  return ElementUI.Message({ ...options, center: true, grouping: true })
}
Vue.prototype.$message.success = function(msg) {
  return ElementUI.Message.success({ message: msg, center: true, grouping: true })
}
Vue.prototype.$message.warning = function(msg) {
  return ElementUI.Message.warning({ message: msg, center: true, grouping: true })
}
Vue.prototype.$message.error = function(msg) {
  return ElementUI.Message.error({ message: msg, center: true, grouping: true })
}
Vue.prototype.$message.info = function(msg) {
  return ElementUI.Message.info({ message: msg, center: true, grouping: true })
}

// 配置axios
Vue.prototype.$axios = axios

const ensureFaviconLink = () => {
  const existing = document.querySelector("link[rel~='icon']")
  if (existing) return existing
  const link = document.createElement('link')
  link.rel = 'icon'
  document.head.appendChild(link)
  return link
}

ensureFaviconLink().href = tu111

// 避免导入SCSS文件以减少警告
// 直接在入口HTML或其他方式中设置CSS变量
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
